export default "__VITE_ASSET__IIBhjXSN__"